// extracted by mini-css-extract-plugin
export var downArrow = "_hd-0";
export var infoTooltipIcon = "_hd-3";
export var label = "_hd-1";
export var optionCard = "_hd-4";
export var upArrow = "_hd-2";